let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fD0Fw")).then(() => parcelRequire('k7LtZ'));